import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, ClosedSelect } from '@piplapps/pipl-ui';
import styles from './SectionHeader.module.less';
import searchIcon from '../../../../../static/img/small-search-icon.png';
import AddUserModal from './AddUserModal';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../Redux/modules/users/actions';
import { StatusFilterMapper, PermissionFilterMapper } from '../constants';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { AppSelectors } from '../../../Redux/modules/app/selectors';

class SectionHeader extends Component {
  handleChange(e) {
    this.props.onFilterChange({ filter: 'user', value: e.target.value });
  }

  handleStatusFilterChange(id) {
    this.props.onFilterChange({ filter: 'status', value: id });
  }

  handlePermissionFilterChange(id) {
    this.props.onFilterChange({ filter: 'permission', value: id });
  }

  handleTeamsFilterChange(id) {
    this.props.onFilterChange({ filter: 'teams', value: id });
  }

  render() {
    const { teams, isTeamManagement } = this.props;
    const modalStyle = {
      width: '500px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      borderRadius: '8px',
      border: 'none',
      backgroundColor: '#ffffff',
    };
    const onClick = () => {
      this.props.clickedAddUserButton();
    };
    const createDot = (color) => {
      return (
        <div style={{ width: 8, height: 8, backgroundColor: color, borderRadius: 8, border: `solid 1px ${color}` }} />
      );
    };

    const statusOptions = [
      { value: StatusFilterMapper.ALL, label: `View all` },
      { value: StatusFilterMapper.ACTIVE, label: `Active`, icon: createDot('#44d7b6') },
      {
        value: StatusFilterMapper.PENDING,
        label: `Pending confirmation`,
        icon: createDot('#fa8a00'),
      },
    ];

    const productPermissionOptions = [
      { value: PermissionFilterMapper.ALL, label: `View all` },
      { value: PermissionFilterMapper.SEARCH, label: `Pipl Subscription` },
      { value: PermissionFilterMapper.ADMIN, label: `Admin` },
    ];
    const teamsList = teams
      ? teams.map((team) => {
          return {
            value: team.name,
            label: team.name,
          };
        })
      : [];
    const missingOptions = [
      { value: 'all', label: 'All' },
      { value: 'unassigned', label: 'Unassigned' },
    ];
    const teamsOptions = missingOptions.concat(teamsList);

    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.selectWrapper}>
            <ClosedSelect
              options={statusOptions}
              name="statusFilter"
              id="statusFilter"
              setValue={(v) => v}
              onChange={(e) => this.handleStatusFilterChange(e)}
              label={gettext('User status')}
              isSearchable={false}
              value={statusOptions[0].value}
              icons
              grey
            />
          </div>
          <div className={styles.selectWrapper}>
            <ClosedSelect
              options={productPermissionOptions}
              name="filter"
              id="filter"
              onChange={(e) => this.handlePermissionFilterChange(e)}
              setValue={(v) => v}
              value={productPermissionOptions[0].value}
              label={gettext('User permissions')}
              isSearchable={false}
              grey
            />
          </div>
          {isTeamManagement && teams?.length > 0 ? (
            <div className={styles.selectWrapper}>
              <ClosedSelect
                options={teamsOptions}
                name="filter"
                id="filter"
                onChange={(e) => this.handleTeamsFilterChange(e)}
                setValue={(v) => v}
                value={teamsOptions[0].value}
                label={gettext('Teams')}
                isSearchable={false}
                grey
              />
            </div>
          ) : null}
        </div>
        <div className={styles.container}>
          <div className={styles.searchBarContainer}>
            <input
              id="users-search-bar"
              className={styles.searchBar}
              type="text"
              placeholder={gettext('Find a user')}
              value={this.props.query}
              onChange={(e) => this.handleChange(e)}
            />
            <img className={styles.searchIcon} src={searchIcon} alt="" />
          </div>
        </div>
      </div>
    );
  }
}

SectionHeader.propTypes = {
  clickedAddUserButton: PropTypes.func,
  query: PropTypes.string,
  onFilterChange: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  teams: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    removeMultipleUsersModalOpen: UsersSelectors.removeMultipleUsersModalSelector(state),
    query: UsersSelectors.userFilterSelector(state),
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
  };
};

const mapDispatchToProps = {
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  onFilterChange: UsersActions.onUserFilterChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionHeader);
